module.exports = __webpack_public_path__ + "static/media/visa-logo.8d66c590.svg";